import contract from '@mailobj-browser/front/js/contracts/contract.js'
import thread from './thread/thread.js'

export default contract({
  thread
})